/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogData } from './models/dialogData';
import { RelationTypes } from '../../../common';
var ApiItemAddDialogComponent = /** @class */ (function () {
    function ApiItemAddDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.multiSelect = true;
        this.selected = data.response.map(function (d) { return d._links.self.href; });
        if (data.property.relationShipType === RelationTypes.SINGLE) {
            this.multiSelect = false;
        }
    } // constructor()
    ApiItemAddDialogComponent.prototype.onOkay = function () {
        this.dialogRef.close(this.selected);
    };
    ApiItemAddDialogComponent = tslib_1.__decorate([
        Component({
            selector: 'ext-api-item-add',
            template: "<mat-dialog-content> <ext-api-table [model]=\"data.property.reference\" [multiSelect]=\"multiSelect\" [(selected)]=\"selected\"></ext-api-table> </mat-dialog-content> <mat-dialog-actions> <button mat-button mat-dialog-close>Cancel</button> <span fxFlex></span> <button mat-button color=\"primary\" (click)=\"onOkay()\">Done</button> </mat-dialog-actions>"
        }),
        tslib_1.__param(1, Inject(MAT_DIALOG_DATA)),
        tslib_1.__metadata("design:paramtypes", [MatDialogRef,
            DialogData])
    ], ApiItemAddDialogComponent);
    return ApiItemAddDialogComponent;
}());
export { ApiItemAddDialogComponent };
//# sourceMappingURL=api-item-add-dialog.component.js.map